<template>
  <div class="px-15" v-if="campaign">
    <div class="btn-group">
      <button
        type="button"
        class="btn btn-primary btn-round dropdown-toggle"
        data-toggle="dropdown"
        aria-expanded="false"
        style="text-transform: uppercase"
      >
        {{ campaign.status }}
      </button>
      <div class="dropdown-menu" role="menu">
        <a
          v-if="campaign.status == 'draft'"
          class="dropdown-item"
          href="javascript:void(0)"
          role="menuitem"
          @click="update('scheduled')"
        >
          <i class="icon md-long-arrow-up" aria-hidden="true"></i>Publish
        </a>
        <a
          v-if="campaign.status == 'draft'"
          class="dropdown-item"
          href="javascript:void(0)"
          role="menuitem"
          @click="update('archived')"
        >
          <i class="icon md-archive" aria-hidden="true"></i>Archive
        </a>
        <a
          v-if="campaign.status == 'scheduled'"
          class="dropdown-item"
          href="javascript:void(0)"
          role="menuitem"
          @click="update('draft')"
        >
          <i class="icon md-long-arrow-down" aria-hidden="true"> </i>
          Unpublished
        </a>

        <a
          v-if="campaign.status == 'ongoing'"
          class="dropdown-item"
          href="javascript:void(0)"
          role="menuitem"
          @click="confirmAborted"
        >
          <i class="icon md-border-color" aria-hidden="true"></i>Abort
        </a>
        <a
          v-if="campaign.status == 'archived'"
          class="dropdown-item"
          href="javascript:void(0)"
          role="menuitem"
          @click="update('draft')"
        >
          <i class="icon md-long-arrow-up" aria-hidden="true"></i>Unarchive
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { progressBarService } from "@/api/client";

export default {
  props: ["campaign"],

  methods: {
    validate(status) {
      const { name, end_date, start_date } = this.campaign;

      const { period, prize_all_picture, background_picture } =
        this.campaign.weekly;

      switch (status) {
        case "scheduled":
          if (!name || name.length > 255) {
            this.$dialogs.alert("กรุณาระบุ Campaign Name ให้ถูกต้อง");
            return false;
          }

          //  End date >= Start
          if (!start_date) {
            this.$dialogs.alert("กรุณาระบุ Start date ให้ถูกต้อง");
            return false;
          }

          if (!end_date) {
            this.$dialogs.alert("กรุณาระบุ End date ให้ถูกต้อง");
            return false;
          }

          if (new Date().getTime() > new Date(start_date).getTime()) {
            this.$dialogs.alert("Start date ต้องยังเป็นอนาคต.");
            return false;
          }

          //  End date >= Start
          if (moment(end_date) < moment(start_date)) {
            this.$dialogs.alert("End date ต้องมากกว่าหรือเท่ากับ Start date.");
            return false;
          }

          // มีรูป Background picture
          if (!background_picture) {
            this.$dialogs.alert("กรุณาระบุ Banner.");
            return false;
          }

          // มีรูป Prize all picture
          if (!prize_all_picture) {
            this.$dialogs.alert("กรุณาระบุ Prize all picture.");
            return false;
          }

          if (period.filter((o) => !!o.period_picture).length < period.length) {
            this.$dialogs.alert(
              "กรุณาระบุรูป Target upload ตามจำนวน Period ที่ตั้งไว้"
            );
            return false;
          }
          break;
      }

      return true;
    },

    async confirmAborted() {
      const r = confirm("คุณต้องการ Abort campaign นี้ใช่หรือไม่?");
      r ? this.update("aborted") : null;
    },

    async update(status) {
      try {
        if (!this.validate(status)) return;

        const { id } = this.campaign;
        const form = {
          status: status,
        };

        await progressBarService.updateCampaignInfo(id, form);
        this.$emit("updated");
        this.$notify("Status updated");
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(error);
      }
    },
  },
};
</script>

<style></style>
